import { ts } from '_core';

import { DraftParams } from './types';

export const prepareData = (resources: ts.StoreState['resources'], data: ts.types.widgets.TableData) => {
  const newData = data.map((item) => {
    const newItem: ts.types.widgets.TableData[number] = { date: item.date };
    Object.keys(item).forEach((key) => {
      let newKey = key;
      let historyType = '';

      if (key != 'date') {
        Object.values(ts.enums.PERIOD_ENUM).forEach((historyEnum) => {
          if (key.startsWith(historyEnum)) {
            historyType = `${historyEnum}_`;
            newKey = key.replace(historyType, '');
          }
        });

        newKey = resources.time_series.find((ts) => ts.handle === newKey)?.name;

        if (newKey) {
          newItem[`${historyType}${newKey}`] = item[key];
        }
      }
    });
    return newItem;
  });
  return newData;
};

export const validate = (params: DraftParams) => {
  if ((params.analysis_time_series_ids || []).length < 1) return ['You need to add at least one time series.'];
  if ((params.analysis_time_series_ids || []).length > 5) return ['You can only add a max of five time series.'];
  return [];
};
